import { Box, Text, Banner } from '@shopify/polaris'

function ErrorView({
  title,
  message,
}: {
  title: string
  message?: string
}): JSX.Element {
  return (
    <Banner
      title={title}
      // action={{content: 'Review risk analysis'}}
      tone="critical"
    >
      {message ? (
        <Box paddingBlockStart="200">
          <Text as="p" variant="bodyMd">
            {message}
          </Text>
        </Box>
      ) : (
        <></>
      )}
    </Banner>
  )
}

export default ErrorView
